import Vue from 'vue'
import VueRouter from 'vue-router'
import About from '../views/About.vue'
import Resume from '../views/Resume.vue'
import Portfolio from '../views/Portfolio.vue'
import Blog from '../views/Blog.vue'
import BlogPost from '../views/BlogPost.vue'
import Contact from '../views/Contact.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'About', component: About },
  { path: '/resume', name: 'Resume', component: Resume },
  { path: '/portfolio', name: 'Portfolio', component: Portfolio },
  { path: '/blog', name: 'Blog', component: Blog },
  { path: '/blog/:slug', name: 'BlogPost', component: BlogPost },
  { path: '/contact', name: 'Contact', component: Contact },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
